'use client';

import { useFormContext, useWatch } from 'react-hook-form';

import type { Product, TailoredApiData } from '@libs/common-types';

import { shouldRenderNearbyStoresCta } from '../lib';
import type { MiniPdpForm } from '../types';

export type UseMiniPdpBopisProps = Readonly<{
    product?: Product;
    tailored: TailoredApiData | null;
    isLoading: boolean;
    isError: boolean;
}>;

export function useMiniPdpBopis({ product, tailored, isLoading, isError }: UseMiniPdpBopisProps) {
    const { control } = useFormContext<MiniPdpForm>();
    const fulfilmentMethod = useWatch({ control, name: 'fulfilmentMethod' });
    const selectedSku = useWatch({ control, name: 'selectedSku' });
    const bopis = selectedSku ? tailored?.variants[selectedSku]?.BOPIS : undefined;
    const storeId = bopis?.storeId;
    const storeData = storeId ? tailored?.bopisStoreData?.[storeId] : undefined;
    const availableStock = bopis?.availableStock ?? 0;
    const minimumCaseQty = product?.deliveryMethods.BOPIS.purchaseQuantities?.min ?? 1;

    return {
        isLoading,
        shouldRender: fulfilmentMethod === 'bopis' && !isError,
        shouldRenderNearbyStoresCTA:
            !isError &&
            shouldRenderNearbyStoresCta({
                fulfilmentMethod,
                storeId,
                availableStock: bopis?.availableStock,
                altAvailableStock: bopis?.altAvailableStock,
            }),
        storeDetails: storeData?.storeDetails ?? null,
        availableStock,
        minimumCaseQty,
    };
}
